export const LoanEditorCustomFormItemKind = {
  LOAN_FIELD: 'LoanField',
  CUSTOM_FIELD: 'CustomField',
};

export const LoanEditorCustomFormSectionKind = {
  FIELDS: 'Fields',
  IFRAME: 'Iframe',
};

export const LOAN_EDITOR_CUSTOM_FORM_IFRAME_DEFAULT_HEIGHT_PX = 600;

export const LoanEditorCustomFormSectionLayout = {
  ONE_COLUMN: 'OneColumn',
  TWO_COLUMNS: 'TwoColumns',
  THREE_COLUMNS: 'ThreeColumns',
  FOUR_COLUMNS: 'FourColumns',
};

export const LOAN_EDITOR_CUSTOM_FORM_SLUG_REGEX = /^[a-z0-9][a-z0-9-]*$/;

export const LOAN_EDITOR_CUSTOM_FORM_NAME_MAX_LENGTH = 100;

export const LOAN_EDITOR_CUSTOM_FORM_SLUG_MAX_LENGTH = 100;

export const LOAN_EDITOR_CUSTOM_FORM_DESCRIPTION_MAX_LENGTH = 500;
